import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as componentStore from '../../component-store'

/**
 * Chart footer component
 */
@ngCore.Component({
  imports: [],
  providers: [],
  selector: 'atn-mosaic-chart-footer',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  public static getLegendItemsFrom({
    content,
    palette,
  }: {
    readonly content?: ents.core.mosaic.Widget.Content<ents.core.mosaic.Widget.Type.Charts>
    readonly palette?: ds.color.Palette
  }) {
    const type = content?.type
    if (
      !type ||
      type === ents.core.display.chart.Type.Donut ||
      type === ents.core.display.chart.Type.Sunburst ||
      type === ents.core.display.chart.Type.Venn
    ) {
      // These charts do not need legends
      return []
    }
    const charts = ents.core.display.chart.Chart.Collection.toCharts<
      typeof type
    >(
      content satisfies ents.core.display.chart.Chart.Collection as ents.core.display.chart.Chart.Collection<
        typeof type
      >,
    )
    const datasets = charts.flatMap(chart =>
      chart.data?.values?.map((group, i) => ({
        ...group,
        color: palette?.getOrAssignColorFor(group.name ?? i.toString()),
      })),
    )

    const uniqueDatasetColors = new Set()
    // Returns datasets filtered by matching color
    return datasets.filter(dataset =>
      uniqueDatasetColors.has(dataset?.color)
        ? false
        : uniqueDatasetColors.add(dataset?.color),
    )
  }

  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.Charts>,
  )

  /** Available color palette for chart point datasets */
  public readonly palette = ds.chart.colors.createPalette()

  // REVIEW: Should we consider duplicate color assignments - currently set in
  // both widget chart and footer components, using the same widget store data
  /** Legend items generated from chart datasets */
  public legendItemsSg = ngCore.computed(
    (content = this.widgetStore.contentSg()) =>
      Component.getLegendItemsFrom({ content, palette: this.palette }),
  )
}
